import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import HeaderTitle from '../../../../../../../common/HeaderTitle';
import { SearchableSelectHookForm, TextAreaHookForm, TextFieldHookForm } from '../../../../../../../layout/HookFormInputs';
import { Controller, useForm } from 'react-hook-form';
import {
    checkWhiteSpaces,
    number,
    alphaNumeric,
    alphabetsOnly,
    notify,
    apiErrors,
    userDetails,
} from '../../../../../../../../helper';

import { API } from '../../../../../../../../config/constants';
import { cloneDeep } from 'lodash';
import TooltipCustom from '../../../../../../../common/Tooltip';
import FileUpload from '../../FileUpload';
import PopupMsgWrapper from '../../../../../../../common/PopupMsgWrapper';
import { getCountryService, getCurrencyList, getCurrencyScaleList } from '../../../../../../supplierListAll/Actions';
import axiosHelper from '../../../../../../../../axiosHelper';
import LoaderCustom from '../../../../../../../common/LoaderCustom';

const fileConfig = {

    cancelledChequeDocument: {
        allowedFileTypes: [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "application/msword", // Allow .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF, JPG, JPEG, PNG, DOC, or DOCX."
    },
    consolidatedRevenueLYDocument: {
        allowedFileTypes: [
            "application/pdf",
            "application/msword", // Allow .doc files
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ],
        maxSize: 5, // In MB
        validationMessage: "Unsupported file type. Please choose a file with one of the following formats: PDF, DOC, or DOCX."
    }
}

let radioValidateMsg = "This field is required.";

let loggedInUserDetail = userDetails();
let currencyMasterListData = [];

const BankDetails = (props) => {
    const history = useHistory()
    const [effectiveDate, setEffectiveDate] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [isApproveKys1PopupOpen, setIsApproveKys1PopupOpen] = useState(false);
    const [isRequestReviewRemarkPopupOpen, setIsRequestReviewRemarkPopupOpen] = useState(false);
    const [requestReviewRemark, setRequestReviewRemark] = useState("");
    const [currencyMasterList, setCurrencyMasterList] = useState([]);
    const [turnOverNumberScaleList, setTurnOverNumberScaleList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [supplierPlantsList, setSupplierPlantsList] = useState([]);
    const [cancelledChequeDocumentAttachment, setCancelledChequeDocumentAttachment] = useState(null)
    const [consolidatedRevenueLYDocumentAttachment, setConsolidatedRevenueLYDocumentAttachment] = useState(null)
    const [consolidatedRevenueLY_1DocumentAttachment, setConsolidatedRevenueLY_1DocumentAttachment] = useState(null)
    const [consolidatedRevenueLY_2DocumentAttachment, setConsolidatedRevenueLY_2DocumentAttachment] = useState(null)
    const [showTabLoader, setShowTabLoader] = useState(true)
    const [bankDetailsToSubmit, setBankDetailsToSubmit] = useState(null)
    const [supplierDetail, setSupplierDetail] = useState(null)
    const selectedTaxtuaryYear = supplierDetail?.TaxationStatutoryDetails?.YearOfBusinessIncorporationName;
    const currentYear = new Date().getFullYear();
    const yearsDifference = currentYear - selectedTaxtuaryYear < 3;

    const [vendorRequirementRegistrationId, setVendorRequirementRegistrationId] = useState(0)
    // 

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            setVendorRequirementRegistrationId(id);
            GetKYS1DetailByVendorRRId(id)
        }
    }, []);
    // GetKYS1DetailByVendorRRId?VendorRequirementRegistrationId=113
    const GetKYS1DetailByVendorRRId = (id) => {
        axiosHelper.get(`${API.GetKYS1DetailByVendorRRId}?VendorRequirementRegistrationId=${id}`)
            .then(async (res) => {
                setSupplierDetail(res?.data?.Data)
            })
            .catch((error) => {

            });
    }

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    const formController = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
    });

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        setValue,
        trigger,
        getValues,
        reset,
        resetField,
        formState: { errors, isSubmitted },
        control,
    } = formController;

    const onPopupConfirmSubmit = () => {
        setShowTabLoader(true);
        setShowPopup(false);
        if (bankDetailsToSubmit) {
            axiosHelper.post(`${API.addAndUpdateKYS1BankDetail}`, bankDetailsToSubmit)
                .then((response) => {
                    if (response.data.IsSuccessful) {
                        notify.success(response?.data?.Data?.Message)
                        hidePageLoader()
                        if (props?.viewDataFromSupplier?.IsBlockedVendor) {
                            history.push("/supplier-unblocking-request");
                        } else {
                            history.push("/vendor-need-list");
                        }
                    }
                })
                .catch((error) => {
                    hidePageLoader();
                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage)
                    }
                });
        }
    };

    const getCurrencyMasterList = () => {
        getCurrencyList()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let list = res?.Data.map(el => ({ label: el?.CurrencyName, value: el?.PCId }));
                    currencyMasterListData = list;
                    setCurrencyMasterList(list);
                }
            })
            .catch(() => { });
    };

    const handleCurrencyChange = async (selectedValue) => {
        const currencyScaleResponse = await getCurrencyScaleList(selectedValue?.value);
        if (currencyScaleResponse?.IsSuccessful) {
            let list = currencyScaleResponse?.Data?.CurrencyScaleList.map(el => ({ label: el.Name, value: el.Id }));
            setTurnOverNumberScaleList(list);
            setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLYType", null)
            setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1Type", null)
            setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2Type", null)
        }
        return;
    }

    const getCountryMasterList = (supplierDetail) => {
        getCountryService()
            .then((res) => {
                if (res?.IsSuccessful) {
                    let formattedList = res?.Data.map(el => ({ label: el.Name, value: el.Id }));
                    setCountryList(formattedList);
                }

                // // For overseas supplier remove India from country list
                // if (supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2) {
                //     let countryListWithoutIndia = formattedList.filter((record) => record.label !== "India");
                //     setCountryList(countryListWithoutIndia);
                // } else {
                //     setCountryList(formattedList);
                // }
            })
            .catch(() => { });
    };

    const getSupplierPlant = () => {
        axiosHelper.get(`${API.getSupplierPlant}`).then((response) => {
            if (response.data?.IsSuccessful) {
                let list = response?.data?.Data?.map(el => ({ label: el.PlantName, value: el.Id }));
                setSupplierPlantsList(list)
            }
        })
            .catch((error) => {
                apiErrors(error);
                throw error; // Re-throw the error to the caller
            });
    }

    useEffect(() => {
        getCurrencyMasterList()
        // getSupplierPlant()
    }, []);

    const getEmptyFileObjectForEditForm = (fileName) => {
        return fileName ? { fileName, base64String: "", fileType: "" } : null;
    }

    const setBankDetailsFormEdit = (BankDetails) => {

        let CancelledChequeDocumentAttachment = getEmptyFileObjectForEditForm(BankDetails?.VendorBankDetails?.CancelledChequeDocumentName);
        let ConsolidatedRevenueLYDocumentAttachment = getEmptyFileObjectForEditForm(BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYDocumentName);
        let ConsolidatedRevenueLY_1DocumentAttachment = getEmptyFileObjectForEditForm(BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1DocumentName);
        let ConsolidatedRevenueLY_2DocumentAttachment = getEmptyFileObjectForEditForm(BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2DocumentName);

        let bankDetailsData = {
            ...BankDetails,
            VendorBankDetails: {
                ...BankDetails.VendorBankDetails,
                Country: !!BankDetails?.VendorBankDetails?.Country ? {
                    value: BankDetails?.VendorBankDetails?.Country,
                    label: BankDetails?.VendorBankDetails?.CountryName
                } : null,
                CancelledChequeDocumentAttachment
            },
            GeneralDetailsOfVendor: {
                ...BankDetails.GeneralDetailsOfVendor,
                ConsolidatedRevenueLYDocumentAttachment,
                ConsolidatedRevenueLY_1DocumentAttachment,
                ConsolidatedRevenueLY_2DocumentAttachment,
                Declartion: BankDetails?.GeneralDetailsOfVendor?.Declartion,
                Invoiceeligibility: BankDetails?.GeneralDetailsOfVendor?.Invoiceeligibility?.toString(),
                PaymentCurrency: !!BankDetails?.GeneralDetailsOfVendor?.PaymentCurrency ? {
                    value: BankDetails?.GeneralDetailsOfVendor?.PaymentCurrency,
                    label: BankDetails?.GeneralDetailsOfVendor?.PaymentCurrencyName
                } : null,
                ConsolidatedRevenueLYType: !!BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYType ? {
                    value: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYType,
                    label: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYTypeName
                } : null,
                ConsolidatedRevenueLY_1Type: !!BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Type ? {
                    value: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Type,
                    label: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1TypeName
                } : null,
                ConsolidatedRevenueLY_2Type: !!BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Type ? {
                    value: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Type,
                    label: BankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2TypeName
                } : null,
                SupplyingPlantId: !!BankDetails?.GeneralDetailsOfVendor?.SupplyingPlantId ? {
                    label: BankDetails?.GeneralDetailsOfVendor?.SupplyingPlantName,
                    value: BankDetails?.GeneralDetailsOfVendor?.SupplyingPlantId,
                } : null
            }
        }

        if (BankDetails?.VendorBankDetails?.Country === 101) {
            let inrCurrenyOnly = currencyMasterListData.filter(currency => currency?.label === "INR");
            setCurrencyMasterList(inrCurrenyOnly);
        }

        reset(bankDetailsData);
        setCancelledChequeDocumentAttachment(CancelledChequeDocumentAttachment)
        setConsolidatedRevenueLYDocumentAttachment(ConsolidatedRevenueLYDocumentAttachment)
        setConsolidatedRevenueLY_1DocumentAttachment(ConsolidatedRevenueLY_1DocumentAttachment)
        setConsolidatedRevenueLY_2DocumentAttachment(ConsolidatedRevenueLY_2DocumentAttachment)
        hidePageLoader()
    }

    useEffect(() => {
        if (supplierDetail?.KYS1ContactDetails) {
            getCountryMasterList(supplierDetail);
        }
        if (supplierDetail?.BankDetails) {
            setBankDetailsFormEdit(supplierDetail?.BankDetails)
        }
    }, [supplierDetail]);

    const onSubmitBankDetails = (values) => {
        let payload = cloneDeep(values);

        payload.VendorBankDetails.KYS1RegistrationId = supplierDetail?.BankDetails?.VendorBankDetails?.KYS1RegistrationId;
        payload.VendorBankDetails.Country = values?.VendorBankDetails.Country?.value;
        // payload.VendorBankDetails.CancelledChequeDocumentAttachment = cancelledChequeDocumentAttachment;

        payload.GeneralDetailsOfVendor.KYS1RegistrationId = supplierDetail?.BankDetails?.GeneralDetailsOfVendor?.KYS1RegistrationId;
        payload.GeneralDetailsOfVendor.PaymentCurrency = values?.GeneralDetailsOfVendor?.PaymentCurrency?.value;
        payload.GeneralDetailsOfVendor.ConsolidatedRevenueLYType = values?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYType?.value;
        payload.GeneralDetailsOfVendor.ConsolidatedRevenueLY_1Type = values?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Type?.value;
        payload.GeneralDetailsOfVendor.ConsolidatedRevenueLY_2Type = values?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Type?.value;
        payload.GeneralDetailsOfVendor.SupplyingPlantId = values?.GeneralDetailsOfVendor?.SupplyingPlantId?.value;
        // payload.GeneralDetailsOfVendor.ConsolidatedRevenueLYDocumentAttachment = consolidatedRevenueLYDocumentAttachment;
        // payload.GeneralDetailsOfVendor.ConsolidatedRevenueLY_1DocumentAttachment = consolidatedRevenueLY_1DocumentAttachment;
        // payload.GeneralDetailsOfVendor.ConsolidatedRevenueLY_2DocumentAttachment = consolidatedRevenueLY_2DocumentAttachment;

        // return;
        setBankDetailsToSubmit(payload);
        setShowPopup(true)
        // axiosHelper.post(`${API.addAndUpdateKYS1BankDetail}`, payload)
        //     .then((response) => {
        //         if (response.data.IsSuccessful) {
        //             notify.success(response?.data?.Data?.Message)
        //             hidePageLoader()
        //         }
        //     })
        //     .catch((error) => {
        //         hidePageLoader();
        //         if (!error?.response?.data?.IsSuccessful) {
        //             notify.error(error?.response?.data?.ErrorMessage)
        //         }
        //     });
    }

    // const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {
    //     const currentFileConfiguration = fileConfig[fileIdentifier];
    //     if (file.size <= (currentFileConfiguration.maxSize * 1024 * 1024)) {
    //         const reader = new FileReader();
    //         reader.onload = (event) => {
    //             let base64String = event.target.result;
    //             // Remove the data type prefix
    //             base64String = base64String.replace(/^data:(.*?);base64,/, "");
    //             // Check if the file type is allowed (PDF, JPG, JPEG, PNG)
    //             const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
    //             const isTypeValid = allowedFileTypes?.includes(file.type);
    //             if (!isTypeValid) {
    //                 // Handle the case where the file type is not allowed
    //                 notify.error(currentFileConfiguration.validationMessage);
    //                 setValue(formFieldKey, null)
    //                 return;
    //             } else {
    //                 // Pass file name, base64String, and fileType to setGstinFile
    //                 let selectedFile = { fileName: file.name, base64String, fileType: file.type };
    //                 setCurrentFile(selectedFile);
    //                 setValue(formFieldKey, selectedFile)
    //                 trigger(formFieldKey)
    //             }

    //         };
    //         reader.readAsDataURL(file);
    //     } else {
    //         // Handle the case where the file size exceeds 5 MB
    //         setValue(formFieldKey, null)
    //         notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
    //     }
    // };
    const handleAttachmentUpload = (file, fileIdentifier, setCurrentFile, formFieldKey) => {
        try {
            // Validate filename for spaces and special characters
            const hasSpecialChars = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]+/.test(file.name);
            const hasSpaces = /\s/.test(file.name);

            if (hasSpaces || hasSpecialChars) {
                notify.error(
                    "Error uploading file. File name should not contain spaces or special characters. Please rename the file and try again."
                );
                setValue(formFieldKey, null);
                return;
            }

            const currentFileConfiguration = fileConfig[fileIdentifier];

            // Validate file size
            if (file.size > (currentFileConfiguration.maxSize * 1024 * 1024)) {
                notify.error(`File size exceeds ${currentFileConfiguration.maxSize} MB. Please choose a smaller file.`);
                setValue(formFieldKey, null);
                return;
            }

            const reader = new FileReader();

            reader.onload = (event) => {
                if (event.target?.result) {
                    let base64String = event.target.result;
                    // Remove the data type prefix
                    base64String = base64String.replace(/^data:(.*?);base64,/, "");

                    // Check if the file type is allowed
                    const allowedFileTypes = currentFileConfiguration.allowedFileTypes;
                    const isTypeValid = allowedFileTypes?.includes(file.type);

                    if (!isTypeValid) {
                        notify.error(currentFileConfiguration.validationMessage);
                        setValue(formFieldKey, null);
                        return;
                    }

                    // Pass file name, base64String, and fileType
                    let selectedFile = {
                        fileName: file.name,
                        base64String,
                        fileType: file.type
                    };

                    setCurrentFile(selectedFile);
                    setValue(formFieldKey, selectedFile);
                    trigger(formFieldKey);
                }
            };

            reader.onerror = () => {
                notify.error("Error uploading file, please connect with your IT team");
                setValue(formFieldKey, null);
            };

            reader.readAsDataURL(file);

        } catch (error) {
            notify.error("Error uploading file, please connect with your IT team");
            setValue(formFieldKey, null);

        }
    };
    const reviewRequestOrApproveKYS1Form = (reqType) => {
        // reqType will be => Approved or ReviewRequested
        // requestReviewRemark
        let payload = {
            "VendorRequirementRegistrationId": vendorRequirementRegistrationId,
            "ActionTakenBy": loggedInUserDetail?.EmployeeId,
            "Action": reqType
        }
        if (reqType === "ReviewRequested") {
            payload.Remark = requestReviewRemark
        }
        axiosHelper.post(`${API.reviewRequestApproveKYS1Form}`, payload)
            .then((response) => {
                if (response.data.IsSuccessful) {
                    notify.success(response?.data?.Data?.Message)
                    // hidePageLoader()
                    reqType === "ReviewRequested" ? setIsRequestReviewRemarkPopupOpen(false) : setIsApproveKys1PopupOpen(false)
                }
            })
            .catch((error) => {
                // hidePageLoader();
                if (error.response.status === 401) {
                    apiErrors(error)
                } else {
                    if (!error?.response?.data?.IsSuccessful) {
                        notify.error(error?.response?.data?.ErrorMessage);
                    }
                }
            });
    }

    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader" />)}
            <div className='hl-bank-details-wrap'>
                {
                    !supplierDetail?.IsKYS1Editable && (
                        <div className='disableKys1Form'> </div>
                    )
                }
                <form onSubmit={handleSubmit(onSubmitBankDetails)}>
                    <Row className="part-detail-wrapper">
                        <Col md="12">
                            <HeaderTitle title={"Bank Details of Supplier"} />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.RTGSCode")}
                                register={register}
                                name="VendorBankDetails.RTGSCode"
                                label={supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 ? "IFSC Code" : `Swift Code`}
                                Controller={Controller}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 30,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={(e) => {
                                    // Convert input value to uppercase
                                    const uppercaseValue = e.target.value.toUpperCase();
                                    e.target.value = uppercaseValue;
                                }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.RTGSCode}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.BankAccountNumber")}
                                register={register}
                                name="VendorBankDetails.BankAccountNumber"
                                label={`Bank Account Number`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 30,
                                }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.BankAccountNumber}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.BankName")}
                                register={register}
                                name="VendorBankDetails.BankName"
                                label={`Bank Name`}
                                Controller={Controller}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 100,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.BankName}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.BankBranch")}
                                register={register}
                                name="VendorBankDetails.BankBranch"
                                label={`Bank Branch`}
                                Controller={Controller}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 100,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.BankBranch}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.Address")}
                                register={register}
                                name="VendorBankDetails.Address"
                                label={`Address`}
                                Controller={Controller}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 100,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.Address}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("VendorBankDetails.City")}
                                register={register}
                                name="VendorBankDetails.City"
                                label={`City`}
                                Controller={Controller}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces },
                                    maxLength: 100,
                                }}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                customClassName={"withBorder"}
                                errors={errors?.VendorBankDetails?.City}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <SearchableSelectHookForm
                                // {...register("VendorBankDetails.Country")}
                                register={register}
                                name="VendorBankDetails.Country"
                                label={"Country"}
                                placeholder={"Select"}
                                Controller={Controller}
                                control={control}
                                rules={{ required: true }}
                                mandatory={true}
                                handleChange={(selectedOption) => {
                                    //When India is selected for Country then only INR currency should be displayed
                                    if (selectedOption?.value === 101) {
                                        let inrCurrenyOnly = currencyMasterListData.filter(currency => currency?.label === "INR");
                                        setCurrencyMasterList(inrCurrenyOnly);
                                        if (inrCurrenyOnly?.length) {
                                            setValue("GeneralDetailsOfVendor.PaymentCurrency", inrCurrenyOnly[0])
                                            handleCurrencyChange(inrCurrenyOnly[0])
                                        }
                                    } else {
                                        setCurrencyMasterList(currencyMasterListData);
                                        setValue("GeneralDetailsOfVendor.PaymentCurrency", null)
                                        setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLYType", null)
                                        setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1Type", null)
                                        setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2Type", null)
                                        setTurnOverNumberScaleList([])
                                    }
                                }}
                                errors={errors?.VendorBankDetails?.Country}
                                disabled={false}
                                options={countryList}
                            />
                        </Col>
                        <Col md="3">
                            <SearchableSelectHookForm
                                // {...register("GeneralDetailsOfVendor.PaymentCurrency")}
                                register={register}
                                name="GeneralDetailsOfVendor.PaymentCurrency"
                                label={"Payment Currency"}
                                placeholder={"Select"}
                                Controller={Controller}
                                control={control}
                                rules={{ required: true }}
                                mandatory={true}
                                handleChange={handleCurrencyChange}
                                errors={errors?.GeneralDetailsOfVendor?.PaymentCurrency}
                                disabled={false}
                                options={currencyMasterList}
                            />
                        </Col>
                        <Col md="6" className='d-flex align-items-center mt-2'>
                            <Label className='me-3 white-space-nowrap'>
                                {
                                    supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 && (
                                        <>
                                            Cancelled cheque
                                        </>
                                    )
                                }
                                {
                                    supplierDetail?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 && (
                                        <>
                                            Duly signed & stamp letter of declaration/PI for bank detail
                                        </>
                                    )
                                }
                                <span className="asterisk-required">*</span>
                            </Label>
                            <FileUpload
                                control={control}
                                uploadClass="hl-iso-upload"
                                {...register("VendorBankDetails.CancelledChequeDocumentAttachment")}
                                onFileChange={(file) => handleAttachmentUpload(file, "cancelledChequeDocument", setCancelledChequeDocumentAttachment, "VendorBankDetails.CancelledChequeDocumentAttachment")}
                                onDelete={() => {
                                    setValue("VendorBankDetails.CancelledChequeDocumentAttachment", null);
                                    setCancelledChequeDocumentAttachment(p => ({ ...p, isRemove: true }))
                                }}
                                uploadedFile={cancelledChequeDocumentAttachment}
                                setUploadedFile={setCancelledChequeDocumentAttachment}
                                allowedFileTypes={fileConfig.cancelledChequeDocument.allowedFileTypes}
                                rules={{ required: "File required" }}
                                errors={errors?.VendorBankDetails?.CancelledChequeDocumentAttachment}
                            />
                        </Col>
                    </Row>
                    <hr className="hr-seprator mt-4" />
                    <Row className="part-detail-wrapper">
                        <Col md="12" className='d-flex align-items-center'>
                            <div>
                                <HeaderTitle title={"General Details of Supplier"} customClass="mt-4" />
                            </div>
                            <div className='ms-4 mb-1'>
                                <TooltipCustom
                                    id="mobileNoTooltip"
                                    tooltipText="(It Should be last 3 years revenue details in decimal)"
                                />
                            </div>
                        </Col>

                        <Col md="3">
                        <div className='ms-4 mb-1'>
                                <TooltipCustom
                                    id="mobileNoTooltip"
                                    tooltipText="(Fill 0 in case of no Last Year Turnover.)."
                                />
                            </div>
                            <TextFieldHookForm
                                // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY")}
                                register={register}
                                name="GeneralDetailsOfVendor.ConsolidatedRevenueLY"
                                label={`Consolidated Last Year Turnover`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, number },
                                    maxLength: 12,
                                }}
                                customClassName={"withBorder"}
                                errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3" className='d-flex mt-4 pt-1'>
                            <SearchableSelectHookForm
                                // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLYType")}
                                register={register}
                                name="GeneralDetailsOfVendor.ConsolidatedRevenueLYType"
                                label={false}
                                placeholder={"Select"}
                                Controller={Controller}
                                control={control}
                                rules={{ required: true }}
                                mandatory={true}
                                handleChange={() => { }}
                                errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYType}
                                disabled={false}
                                options={turnOverNumberScaleList}
                            />
                            <div className='mt-1 d-flex'>
                                <FileUpload
                                    control={control}
                                    uploadClass="hl-iso-upload"
                                    {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLYDocumentAttachment")}
                                    onFileChange={(file) => handleAttachmentUpload(file, "consolidatedRevenueLYDocument", setConsolidatedRevenueLYDocumentAttachment, "GeneralDetailsOfVendor.ConsolidatedRevenueLYDocumentAttachment")}
                                    onDelete={() => {
                                        setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLYDocumentAttachment", null);
                                        setConsolidatedRevenueLYDocumentAttachment(p => ({ ...p, isRemove: true }))
                                    }}
                                    uploadedFile={consolidatedRevenueLYDocumentAttachment}
                                    setUploadedFile={setConsolidatedRevenueLYDocumentAttachment}
                                    allowedFileTypes={fileConfig.consolidatedRevenueLYDocument.allowedFileTypes}
                                    rules={{ required: "File required" }}
                                    errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYDocumentAttachment}
                                    mandatory={true}
                                />
                            </div>
                        </Col>
                        <Col md='12'>
                            <Row>
                                <Col md="3">
                                    <TextFieldHookForm
                                        // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1")}
                                        register={register}
                                        name="GeneralDetailsOfVendor.ConsolidatedRevenueLY_1"
                                        label={`Consolidated Last Year Turnover (Y-1)`}
                                        Controller={Controller}
                                        control={control}
                                        placeholder={"Enter"}
                                        handleChange={() => { }}
                                        rules={{
                                            required: true,
                                            validate: { checkWhiteSpaces, number },
                                            maxLength: 12,
                                        }}
                                        customClassName={"withBorder"}
                                        errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1}
                                        disabled={false}
                                        mandatory={true}
                                    />
                                </Col>
                                <Col md="3" className='d-flex mt-4 pt-1'>
                                    <SearchableSelectHookForm
                                        // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1Type")}
                                        register={register}
                                        name="GeneralDetailsOfVendor.ConsolidatedRevenueLY_1Type"
                                        label={false}
                                        placeholder={"Select"}
                                        Controller={Controller}
                                        control={control}
                                        rules={{ required: yearsDifference }}
                                        mandatory={yearsDifference}
                                        handleChange={() => { }}
                                        errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Type}
                                        disabled={false}
                                        options={turnOverNumberScaleList}
                                    />
                                    <div className='mt-1 d-flex'>
                                        <FileUpload
                                            control={control}
                                            uploadClass="hl-iso-upload"
                                            {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1DocumentAttachment")}
                                            onFileChange={(file) => handleAttachmentUpload(file, "consolidatedRevenueLYDocument", setConsolidatedRevenueLY_1DocumentAttachment, "GeneralDetailsOfVendor.ConsolidatedRevenueLY_1DocumentAttachment")}
                                            onDelete={() => {
                                                setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_1DocumentAttachment", null);
                                                setConsolidatedRevenueLY_1DocumentAttachment(p => ({ ...p, isRemove: true }))
                                            }}
                                            uploadedFile={consolidatedRevenueLY_1DocumentAttachment}
                                            setUploadedFile={setConsolidatedRevenueLY_1DocumentAttachment}
                                            allowedFileTypes={fileConfig.consolidatedRevenueLYDocument.allowedFileTypes}
                                            rules={{ required: "File required" }}
                                            mandatory={true}
                                            errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1DocumentAttachment}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md='12'>
                            <Row className='d-flex align-items-center'>
                                <Col md='12'>
                                    <Row>
                                        <Col md="3">
                                            <TextFieldHookForm
                                                // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2")}
                                                register={register}
                                                name="GeneralDetailsOfVendor.ConsolidatedRevenueLY_2"
                                                label={`Consolidated Last Year Turnover (Y-2)`}
                                                Controller={Controller}
                                                control={control}
                                                placeholder={"Enter"}
                                                handleChange={() => { }}
                                                rules={{
                                                    required: false,
                                                    validate: { checkWhiteSpaces, number },
                                                    maxLength: 12,
                                                }}
                                                customClassName={"withBorder"}
                                                errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2}
                                                disabled={false}
                                                mandatory={false}
                                            />
                                        </Col>
                                        <Col md="3" className='d-flex mt-4 pt-1'>
                                            <SearchableSelectHookForm
                                                // {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2Type")}
                                                register={register}
                                                name="GeneralDetailsOfVendor.ConsolidatedRevenueLY_2Type"
                                                label={false}
                                                placeholder={"Select"}
                                                Controller={Controller}
                                                control={control}
                                                rules={{ required: false }}
                                                mandatory={false}
                                                handleChange={() => { }}
                                                errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Type}
                                                disabled={false}
                                                options={turnOverNumberScaleList}
                                            />
                                            <div className='mt-1 d-flex'>
                                                <FileUpload
                                                    control={control}
                                                    uploadClass="hl-iso-upload"
                                                    {...register("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2DocumentAttachment")}
                                                    onFileChange={(file) => handleAttachmentUpload(file, "consolidatedRevenueLYDocument", setConsolidatedRevenueLY_2DocumentAttachment, "GeneralDetailsOfVendor.ConsolidatedRevenueLY_2DocumentAttachment")}
                                                    onDelete={() => {
                                                        setValue("GeneralDetailsOfVendor.ConsolidatedRevenueLY_2DocumentAttachment", null); setConsolidatedRevenueLY_2DocumentAttachment(p => ({ ...p, isRemove: true }))
                                                    }}
                                                    uploadedFile={consolidatedRevenueLY_2DocumentAttachment}
                                                    setUploadedFile={setConsolidatedRevenueLY_2DocumentAttachment}
                                                    allowedFileTypes={fileConfig.consolidatedRevenueLYDocument.allowedFileTypes}
                                                    rules={{ required: false }}
                                                    errors={errors?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2DocumentAttachment}
                                                    mandatory={false}
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col md="12">
                                    <div className="hl-title-tooltip">
                                        <label>
                                            Whether E-Invoice Enabled Supplier<span className="asterisk-required">*</span>
                                        </label>
                                    </div>
                                    <Label
                                        className="d-inline-block align-middle w-auto pl-2 pr-5 mr-5 pr-4 pt-0 radio-box"
                                        check
                                    >
                                        <input
                                            type="radio"
                                            // name="GeneralDetailsOfVendor.Invoiceeligibility"
                                            // rules={{ required: true }}
                                            className="zero-based"
                                            value={true}
                                            {...register("GeneralDetailsOfVendor.Invoiceeligibility", { required: radioValidateMsg })}
                                        // defaultChecked
                                        />
                                        <span>Yes</span>
                                    </Label>
                                    <Label
                                        className="d-inline-block align-middle w-auto pl0 pt-0 radio-box"
                                        check
                                    >
                                        <input
                                            type="radio"
                                            // name="GeneralDetailsOfVendor.Invoiceeligibility"
                                            // rules={{ required: true }}
                                            className="vendor-based"
                                            value={false}
                                            {...register("GeneralDetailsOfVendor.Invoiceeligibility", { required: radioValidateMsg })}
                                        />
                                        <span>No</span>
                                    </Label>
                                    {errors?.GeneralDetailsOfVendor?.Invoiceeligibility && (
                                        <div className="text-help">
                                            {errors?.GeneralDetailsOfVendor?.Invoiceeligibility?.message}
                                        </div>
                                    )}
                                </Col>
                                <Col md="3">
                                    <TextAreaHookForm
                                        // {...register("GeneralDetailsOfVendor.MainCustomers")}
                                        register={register}
                                        name="GeneralDetailsOfVendor.MainCustomers"
                                        label={"Main Customers"}
                                        rules={{
                                            required: true,
                                            validate: {
                                                checkWhiteSpaces,
                                                // alphaNumeric
                                            },
                                            maxLength: 250,
                                        }}
                                        placeholder={true ? "Enter" : "Type here..."}
                                        Controller={Controller}
                                        control={control}
                                        mandatory={true}
                                        customClassName={"withBorder"}
                                        handleChange={() => { }}
                                        errors={errors?.GeneralDetailsOfVendor?.MainCustomers}
                                        disabled={false}
                                        rowHeight={3}
                                    />
                                </Col>
                                <Col md="3">
                                    <TextAreaHookForm
                                        // {...register("GeneralDetailsOfVendor.MainProduct")}
                                        register={register}
                                        name="GeneralDetailsOfVendor.MainProduct"
                                        label={"Main Product/Services"}
                                        rules={{
                                            required: true,
                                            validate: {
                                                checkWhiteSpaces,
                                                // alphaNumeric
                                            },
                                            maxLength: 250,
                                        }}
                                        placeholder={true ? "Enter" : "Type here..."}
                                        Controller={Controller}
                                        control={control}
                                        mandatory={true}
                                        customClassName={"withBorder"}
                                        handleChange={() => { }}
                                        errors={errors?.GeneralDetailsOfVendor?.MainProduct}
                                        disabled={false}
                                        rowHeight={3}
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <hr className="hr-seprator mt-4" />
                    <Row className="part-detail-wrapper">
                        <Col md="12" className='d-flex align-items-center'>
                            <HeaderTitle title={"Authorised Signatory"} customClass="mt-4" />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("GeneralDetailsOfVendor.AuthorisedSignatory_Name")}
                                register={register}
                                name="GeneralDetailsOfVendor.AuthorisedSignatory_Name"
                                label={`Name`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                    maxLength: 100,
                                }}
                                customClassName={"withBorder"}
                                errors={errors?.GeneralDetailsOfVendor?.AuthorisedSignatory_Name}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md="3">
                            <TextFieldHookForm
                                // {...register("GeneralDetailsOfVendor.AuthorisedSignatory_Designation")}
                                register={register}
                                name="GeneralDetailsOfVendor.AuthorisedSignatory_Designation"
                                label={`Designation`}
                                Controller={Controller}
                                control={control}
                                placeholder={"Enter"}
                                handleChange={() => { }}
                                rules={{
                                    required: true,
                                    validate: { checkWhiteSpaces, alphabetsOnly },
                                    maxLength: 100,
                                }}
                                customClassName={"withBorder"}
                                errors={errors?.GeneralDetailsOfVendor?.AuthorisedSignatory_Designation}
                                disabled={false}
                                mandatory={true}
                            />
                        </Col>
                        <Col md='12' className='mt-4'>
                            {/* <Form> */}
                            <FormGroup check inline className='pl-0'>
                                <label className='text-danger'><strong>Note: </strong>If there is any changes in future in above information, immediately inform to concern Havells Team</label>
                            </FormGroup>
                            {/* </Form> */}
                        </Col>
                        {/* <Col md="3">
                            <SearchableSelectHookForm
                                // {...register("GeneralDetailsOfVendor.SupplyingPlantId")}
                                register={register}
                                name="GeneralDetailsOfVendor.SupplyingPlantId"
                                label={`Supplying to which plants of Havells`}
                                placeholder={"Select"}
                                Controller={Controller}
                                control={control}
                                mandatory={true}
                                handleChange={() => { }}
                                errors={errors?.GeneralDetailsOfVendor?.SupplyingPlantId}
                                disabled={true}
                                options={supplierPlantsList}
                            />
                        </Col> */}
                    </Row>
                    <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer mt-3">
                        <div className="col-sm-12 text-right bluefooter-butn d-flex justify-content-end align-items-center">
                            <span className='text-start'>
                                <FormGroup check inline>
                                    <Label check className='custom-checkbox mb-0'>
                                        I hereby declare that all the information given by me in this application is true and correct to the best of my knowledge and belief<span className="asterisk-required">*</span>
                                        <Controller
                                            name="GeneralDetailsOfVendor.Declartion"
                                            control={control}
                                            rules={{ required: "This field is required." }}
                                            render={({ field }) => <input checked={field.value} type="checkbox" {...field} />}
                                        />
                                        <span className="before-box"></span>
                                    </Label>
                                    {
                                        errors && errors.GeneralDetailsOfVendor?.Declartion?.message && (
                                            <span className="text-help d-block">
                                                {errors.GeneralDetailsOfVendor.Declartion.message}
                                            </span>
                                        )
                                    }
                                </FormGroup>
                            </span>
                            <button type={"button"} className="reset mr-2 cancel-btn" onClick={() => props.toggleKys1FormTabs("3")}>
                                <i className="fa fa-long-arrow-left me-2" aria-hidden="true"></i>
                                Previous
                            </button>
                            <button type="submit" className="submit-button save-btn">
                                <div className="send-for-approval mr-1"></div>
                                Submit Details
                            </button>
                            <PopupMsgWrapper
                                firstButtonName="Proceed"
                                secondButtonName="Cancel"
                                header=""
                                isOpen={showPopup}
                                closePopUp={() => setShowPopup(false)}
                                confirmPopup={onPopupConfirmSubmit}
                                message={
                                    <>
                                        Do you really want to proceed?
                                    </>
                                }
                                iconClass="d-none"
                                imgClass="hl-img-confirmation"
                                popupWrapper="popup-wrapper-main"

                            />
                            <PopupMsgWrapper
                                firstButtonName="Proceed"
                                secondButtonName="Cancel"
                                header=""
                                isOpen={isApproveKys1PopupOpen}
                                closePopUp={() => setIsApproveKys1PopupOpen(false)}
                                confirmPopup={() => reviewRequestOrApproveKYS1Form("Approved")}
                                message={
                                    <>
                                        Approve KYS1 request?
                                    </>
                                }
                                iconClass="d-none"
                                imgClass="hl-img-confirmation"
                                popupWrapper="popup-wrapper-main"

                            />
                            {
                                isRequestReviewRemarkPopupOpen && (
                                    <PopupMsgWrapper
                                        firstButtonName="Submit"
                                        secondButtonName="Cancel"
                                        header=""
                                        isOpen={isRequestReviewRemarkPopupOpen}
                                        isInputField={true}
                                        setInputData={(data) => {
                                            setRequestReviewRemark(data);
                                            setRequestReviewRemark("")
                                        }}
                                        closePopUp={() => setIsRequestReviewRemarkPopupOpen(false)}
                                        // confirmPopup={() => reviewRequestOrApproveKYS1Form("ReviewRequested")}
                                        confirmPopup={() => {
                                            if (!requestReviewRemark) {
                                                setIsRequestReviewRemarkPopupOpen(true);
                                            } else {
                                                reviewRequestOrApproveKYS1Form("ReviewRequested")
                                            }
                                        }}
                                        iconClass="d-none"
                                        imgClass="hl-img-confirmation"
                                        popupWrapper="popup-wrapper-main"

                                    />
                                )
                            }
                        </div>
                    </Row>
                </form>
            </div>
        </>
    )
}
export default BankDetails;